export default {
  title: {
    id: 'bo_seller.orders.drawers.fix_order_issue.modal_title',
    defaultMessage: 'Fix order issue',
  },
  back: {
    id: 'bo_seller.orders.drawers.fix_order_issue.back',
    defaultMessage: 'Back',
  },
  cancel: {
    id: 'bo_seller.orders.drawers.fix_order_issue.keep_order',
    defaultMessage: 'No, keep this order',
  },
  outOfStockTitle: {
    id: 'bo_seller.orders.drawers.fix_order_issue.out_of_stock_title',
    defaultMessage: 'Product out of stock',
  },
  deliveryIssueTitle: {
    id: 'bo_seller.orders.drawers.fix_order_issue.delivery_issue_title',
    defaultMessage: 'Issue with delivery',
  },
  otherIssueTitle: {
    id: 'bo_seller.orders.drawers.fix_order_issue.other_issue_title',
    defaultMessage: 'Other',
  },
} as const
